import { Grid } from '@mui/material';
import logo from '../../../Assets/logos/services_aust_logo.png';
import './Agreement.css';
import '../../../css/Mpa.css';
import '../../../css/App.css';
import { MerchantInformation } from '../../../Models/MerchantInformation';

export interface AgreementProps {
    merchantInformation: MerchantInformation;
}

export const Agreement = (props: AgreementProps) => {
    const { legalName, businessName, abn, fullAddress } = props.merchantInformation;
    const mode = "display";

    const getClassName = (category : string) => {
        return "agreement_" + mode + "_" + category;
    }

    // Show blank space manual fill-in if legal entity name could not be auto-filled by ABN Lookup
    const displayLegalName = legalName ? legalName : '_'.repeat(70);
    

    return (
        <>
            <div className={getClassName("divWidth")}>   
                <img src={logo} alt="" className={getClassName("dssLogo")} />
				<p className={getClassName("heading")}><b>Product Level Blocking Merchant Participation Agreement</b></p>
                <p className={getClassName("body")}><b>Between</b> <span className='wrapAnywhere'>{displayLegalName}</span> <span className='noWrap'>ABN {abn}</span> trading as {businessName} of {fullAddress} <b>'Merchant' And the </b>Commonwealth of Australia, as represented by Services Australia ABN 90 794 605 008 of 57 Athllon Drive Greenway ACT 2900, <b className={getClassName("no_wrap")}>‘Services Australia’</b>.</p>
                
                <p className={getClassName("body")}>This Agreement outlines the respective undertakings of the Merchant and Services Australia regarding the Merchant’s participation in Product Level Blocking (PLB).</p>
                
                <p className={getClassName("body")+" mb-0"}>The objective of PLB is to enable Merchants to implement an automated method for preventing  customers paying for goods and services that are restricted  under the enhanced Income Management program with a SmartCard,  including:</p>
                <ul className={getClassName("ul")}>
                    <li className={getClassName("li")}>
                        alcohol or home brew kits</li>
                    <li className={getClassName("li")}>
                        tobacco or tobacco products</li>
                    <li className={getClassName("li")}>
                        gambling</li>
                    <li className={getClassName("li")}>
                        pornography</li>
                    <li className={getClassName("li")}>
                        cash-like products, including some gift cards</li>
                </ul >
                <p className={getClassName("body")+" mt-0"}>Additionally, customers cannot withdraw cash using a SmartCard.</p>

                <p className={getClassName("body")+" mb-0"}><b>Services Australia, as supported by its third party service providers relevant to the Program, undertakes to:</b></p>
                
                <ul className={getClassName("ul")}>
                    <li className={getClassName("li")}>
                        engage with the Merchant’s supplier of point of sale software (POS Provider)</li>
                    <li className={getClassName("li")}>
                        engage with the Merchant’s card payments acquiring institution (Acquirer)</li>
                    <li className={getClassName("li")}>
                        work with the POS Provider and Acquirer to update the Merchant’s POS System, and</li>
                    <li className={getClassName("li")}>
                        engage the POS Provider to provide training to the Merchant’s staff at no cost to the Merchant.</li>
                </ul >
                <p className={getClassName("body")+" mb-0"}><b>Services Australia undertakes to:</b></p>
                <ul className={getClassName("ul")}>
                    <li className={getClassName("li")}>
                    assist the Merchant with identification of Restricted Items in the Merchant's product range.</li>
                </ul >
                <p className={getClassName("body")+" mb-0"}><b>In consideration for Services Australia facilitating the above, the Merchant undertakes to:</b></p>
                <ul className={getClassName("ul")}>
                    <li className={getClassName("li")}>
                        permit the Merchant’s POS system to be assessed for updates or changes required to implement PLB and permit these updates to implement PLB</li>
                    <li className={getClassName("li")}>
                        identify all restricted goods and services that the Merchant offers during the period of the Merchant’s participation in PLB</li>
                    <li className={getClassName("li")}>
                        ensure that only goods and services intended to be restricted per legislation are subject to PLB</li>
                    <li className={getClassName("li")}>
                        co-operate with third party service providers engaged by Services Australia to deliver PLB</li>
                    <li className={getClassName("li")}>
                        provide feedback upon request to Services Australia regarding any impact upon the Merchant’s customers and staff resulting from the Merchant’s participation in PLB</li>
                    <li className={getClassName("li")}>
                        advise Services Australia promptly of any changes including a change in acquirer, terminals and/or POS system</li>
                    <li className={getClassName("li")}>
                        maintain terminals to an integrated mode once PLB is implemented, and</li>
                    <li className={getClassName("li")}>
                        acknowledge that if PLB is not used as intended, Services Australia may impose a sanction as a result of non-compliance (including blocking the Merchant from accepting the SmartCard).</li>
                </ul>

                <p className={getClassName("body")}>Services Australia shall not be liable in any event for any losses which may be suffered by the Merchant as a result of the Merchant being blocked for failure to use PLB as intended.</p>
                <p className={getClassName("body")}>The Merchant consents to allow SmartCard purchase transaction data from the Merchant’s POS system to be uploaded and stored in a secure central database to be used only for the purpose of managing and evaluating the Program, noting that any information collected will be de-identified before storing.</p>               
                <br />

                <div className="agreement_table">
                    <Grid container>
                        <Grid item xs={12} md={3} className='agreement_text_rightAlign' sx={{mb: '45px'}}>
                            <b>Signed for the Merchant:</b>
                        </Grid>
                        <Grid item xs={12} md={9} sx={{mb: '45px', borderBottom: '1px', borderBottomStyle: 'solid'}}/>

                        <Grid item xs={12} md={3} className='agreement_text_rightAlign' sx={{mb: '45px'}}>
                            Name:
                        </Grid>
                        <Grid item xs={12} md={9} sx={{mb: '45px', borderBottom: '1px', borderBottomStyle: 'solid'}}/>
                        <Grid item xs={12} md={3} className='agreement_text_rightAlign' sx={{mb: '45px'}}>
                            Position:
                        </Grid>
                        <Grid item xs={12} md={9} sx={{mb: '45px', borderBottom: '1px', borderBottomStyle: 'solid'}}/>

                        <Grid item xs={12} md={3} className='agreement_text_rightAlign' sx={{mb: '45px'}}>
                            <b>Signed for Services Australia:</b>
                        </Grid>
                        <Grid item xs={12} md={9} sx={{mb: '45px', borderBottom: '1px', borderBottomStyle: 'solid'}}/>

                        <Grid item xs={12} md={3} className='agreement_text_rightAlign' sx={{mb: '45px'}}>
                            Agency representative:
                        </Grid>
                        <Grid item xs={12} md={9} sx={{mb: '45px', borderBottom: '1px', borderBottomStyle: 'solid'}}/>
                        <Grid item xs={12} md={3} className='agreement_text_rightAlign' sx={{mb: '45px'}}>
                            Position:
                        </Grid>
                        <Grid item xs={12} md={9} sx={{mb: '45px', borderBottom: '1px', borderBottomStyle: 'solid'}}/>

                        <Grid item xs={12} md={3} className='agreement_text_rightAlign' sx={{mb: '45px'}}>
                            Date:
                        </Grid>
                        <Grid item xs={12} md={9} sx={{mb: '45px', borderBottom: '1px', borderBottomStyle: 'solid'}}/>

                    </Grid>
                </div>
            </div>
        </>
    );
}
